// Lightweight wrapper that just renders children. The original
// `maquina-de-corte` module assumed a richer top-level chrome; in this app
// the surrounding chrome is provided by AppShell.js, so we only forward.
import React from "react";

export default function MainLayout({ title, children }) {
  return (
    <div className="min-h-full w-full" data-page-title={title || ""}>
      {children}
    </div>
  );
}
